import { Message, sendMessage } from '../Communication';

/** @internal */
export interface DescriptorAction {
    descriptor: string;
}

/** @internal */
export interface PathActions {
    path: string;
}

/** @internal */
export interface CopyAction {
    source: string;
    destination: string;
    override: boolean;
}

export type OpenMode = 'r' | 'w' | 'a';
export type Converter = '' | 'base64';

/** @internal */
export interface OpenAction extends PathActions {
    mode: OpenMode;
    converter: Converter;
}

/** @internal */
export interface ReadAction extends DescriptorAction {
    size: number;
}

/** @internal */
export interface WriteAction extends DescriptorAction {
    data: string;
}

export function close(descriptor: string): Promise<void> {
    return sendMessage<Message<DescriptorAction>>({
        type: 'fs',
        action: 'close',
        arguments: {
            descriptor: descriptor
        }
    });
}

export function copy(src: string, dst: string, override: boolean): Promise<void> {
    return sendMessage<Message<CopyAction>>({
        type: 'fs',
        action: 'copy',
        arguments: {
            source: src,
            destination: dst,
            override: override
        }
    });
}

export function flush(descriptor: string): Promise<void> {
    return sendMessage<Message<DescriptorAction>>({
        type: 'fs',
        action: 'flush',
        arguments: {
            descriptor: descriptor
        }
    });
}

export function list(path: string): Promise<Array<string>> {
    return sendMessage<Message<PathActions>, Array<string>>({
        type: 'fs',
        action: 'list',
        arguments: {
            path: path
        }
    });
}

export function open(path: string, mode: OpenMode, converter: Converter): Promise<string> {
    return sendMessage<Message<OpenAction>, string>({
        type: 'fs',
        action: 'open',
        arguments: {
            path: path,
            mode: mode,
            converter: converter
        }
    });
}

export function read(descriptor: string, length: number): Promise<string> {
    return sendMessage<Message<ReadAction>, string>({
        type: 'fs',
        action: 'read',
        arguments: {
            descriptor: descriptor,
            size: length
        }
    });
}

export function remove(path: string): Promise<void> {
    return sendMessage<Message<PathActions>>({
        type: 'fs',
        action: 'remove',
        arguments: {
            path: path
        }
    });
}

export function size(path: string): Promise<number> {
    return sendMessage<Message<PathActions>, number>({
        type: 'fs',
        action: 'size',
        arguments: {
            path: path
        }
    });
}

export function write(descriptor: string, data: string): Promise<void> {
    return sendMessage<Message<WriteAction>>({
        type: 'fs',
        action: 'write',
        arguments: {
            descriptor: descriptor,
            data: data
        }
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/app-api/Filesystem/Wrapper.ts